<template>
    <a @click="toggle()">
        <div class="background"
             :style="{ backgroundColor: bgColor }"
        >
            <span>{{ association.name }}</span>
        </div>
    </a>
</template>

<script>
    export default {
        name: "ToggleButton",
        props: {
            association: {
                type: Object,
                required: true
            }
        },
        computed: {
            bgColor() {
                let baseColor = this.association.options.style().fillColor;
                let opacity = this.association.show ? 1 : 0.5;
                return this.hexToRGB(baseColor, opacity)
            }
        },
        methods: {
            toggle() {
                this.association.show = !this.association.show
            },
            hexToRGB(hex, alpha) {
                let r = parseInt(hex.slice(1, 3), 16),
                    g = parseInt(hex.slice(3, 5), 16),
                    b = parseInt(hex.slice(5, 7), 16);

                if (alpha) {
                    return `rgba(${r},${g},${b},${alpha})`;
                    // return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
                } else {
                    return `rgb(${r},${g},${b})`;
                    // return "rgb(" + r + ", " + g + ", " + b + ")";
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    a {
        color: #fff;
        overflow: hidden;
        background: linear-gradient(
                        to bottom,
                        rgba(255, 255, 255, .5) 0%,
                        rgba(255, 255, 255, .3) 20%,
                        rgba(255, 255, 255, .1) 21%,
                        rgba(255, 255, 255, 0) 100%
        );
        box-shadow: inset 0 0 20px 1px #333333;
        border-radius: 15px;
        font-size: 14px;
        &:hover, &:active, &:focus {
            background: linear-gradient(
                            to bottom,
                            rgba(100, 100, 100, .7) 0%,
                            rgba(100, 100, 100, .5) 20%,
                            rgba(100, 100, 100, .3) 21%,
                            rgba(100, 100, 100, 0) 100%
            );
        }

        display: flex;

        .background {
            flex: 1 1;
            position: relative;
            z-index: -1;
            padding: .25em;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            span {
                position: relative;
                z-index: 1;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/partials/ToggleButton.vue